import "@fontsource/archivo/400.css";
import "@fontsource/archivo/600.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fortex/map/style.css";
import "./styles/base.css";
import "./styles/app.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { decode } from "@fortex/map";
import { AppProvider, readStoredTheme } from "./app/context";
import type { AppServices } from "./app/context";
import { createAppRouter } from "./app/routes";
import { createShellCore } from "./app/shellCore";
import { createAuthStore } from "./auth/store";
import { appConfig, buildApi, langFromSearch, loginPath } from "./config";
import { appLabelsFor } from "./i18n";

const config = appConfig();
const auth = createAuthStore();
const initialLang = langFromSearch(window.location.search, config.defaultLang);
const initialTheme = decode(window.location.search).theme ?? readStoredTheme() ?? config.theme;
const router = createAppRouter(config.basePath);

const api = buildApi({
  config,
  lang: initialLang,
  token: () => auth.getState().token,
  onUnauthorized: () => {
    if (auth.getState().token === null) return;

    auth.getState().logout();

    const here = `${router.state.location.pathname}${router.state.location.search}`;

    void router.navigate(loginPath(here), { replace: true });
  }
});

const services: AppServices = { config, api, auth, shell: createShellCore(appLabelsFor(initialLang)), initialLang, initialTheme };

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProvider services={services}>
      <RouterProvider router={router} />
    </AppProvider>
  </StrictMode>
);
